export const DELETE_TAXONOMY_COMPLETED = 'Taxonomy.deleteTaxonomyCompleted';

interface DeleteTaxonomyCompleted {
  type: typeof DELETE_TAXONOMY_COMPLETED
}

export type TaxonomyActionTypes
  = DeleteTaxonomyCompleted
